import { EXPENSES_ENDPOINTS } from "@/features/vouchers/config/paths";
import { GroupedExpensesResponse } from "@/features/vouchers/types/groupedExpense.type";
import { fetcher } from "@/shared/lib/fetcher.client";

type GroupedExpenseParams = { payment_id: string };

export const getGroupedExpenses = async (params: GroupedExpenseParams): Promise<GroupedExpensesResponse> => {
  const searchParams = new URLSearchParams();
  searchParams.append("by", "transaction");
  searchParams.append("q[payment_id_eq]", params.payment_id);

  const response = await fetcher.get<GroupedExpensesResponse>(EXPENSES_ENDPOINTS.GET_GROUPED_EXPENSES, { params: Object.fromEntries(searchParams.entries()) });
  return response.data;
};
